import { LoggingServicePort, LogTransportPort } from '../../ports'

type LogLabelsParam = Record<string, string | number | boolean>

export class LoggingAdapter implements LoggingServicePort {
  constructor(
    private readonly logTransport: LogTransportPort,
    private readonly random: () => number = Math.random
  ) {}

  static readonly NAMESPACE = 'eprivacy_consentBanner'

  logMessageWithId(
    id: `${Uppercase<string>}.${string}`,
    message: string | undefined,
    labels?: LogLabelsParam
  ): void {
    void this.transportInfo(id, message, labels)
  }

  logMessage(message: string | undefined, labels?: LogLabelsParam): void {
    void this.transportInfo(undefined, message, labels)
  }

  logErrorWithId(
    id?: `${Uppercase<string>}.${string}`,
    message?: string | Error,
    labels?: LogLabelsParam
  ): void {
    this.logTransport.ERROR(this.prepareNamespaceId(id), message, labels)
  }

  logError(error: unknown, labels?: LogLabelsParam): void {
    if (error instanceof Error || typeof error === 'string') {
      return this.logErrorWithId(undefined, error, labels)
    }
    return this.logErrorWithId(undefined, JSON.stringify(error), labels)
  }

  sample(
    sampleRate: number,
    message: string | undefined,
    labels?: LogLabelsParam
  ): void {
    if (this.random() < sampleRate) {
      this.logTransport.INFO(this.prepareNamespaceId(), message, {
        ...labels,
        sampleRate,
      })
    }
  }

  private transportInfo(
    id?: string,
    message?: string,
    labels?: LogLabelsParam
  ): void {
    this.logTransport.INFO(this.prepareNamespaceId(id), message, labels)
  }

  private prepareNamespaceId(extraId?: string): string {
    return `${LoggingAdapter.NAMESPACE}${extraId ? '.' + extraId : ''}`
  }
}
